var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppearanceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 .75C5.812.75.75 5.813.75 12c0 6.188 5.063 11.25 11.25 11.25.984 0 1.828-.844 1.828-1.828 0-.422-.14-.985-.422-1.266-.281-.281-.422-.703-.422-1.265 0-.985.844-1.828 1.829-1.828h2.25c3.515 0 6.187-2.813 6.187-6.188C23.25 5.25 18.187.75 12 .75zM5.11 12c-.985 0-1.829-.844-1.829-1.828 0-.985.844-1.828 1.828-1.828.985 0 1.829.844 1.829 1.828 0 .984-.844 1.828-1.829 1.828zm3.796-5.063c-1.125 0-1.969-.843-1.969-1.828 0-.984.844-1.828 1.97-1.828 1.124 0 1.827.844 1.827 1.828 0 .985-.843 1.829-1.828 1.829zm6.188 0c-.985 0-1.828-.843-1.828-1.828 0-.984.843-1.828 1.828-1.828.984 0 1.828.844 1.828 1.828 0 .985-.703 1.829-1.828 1.829zM18.89 12c-.985 0-1.828-.844-1.828-1.828 0-.985.843-1.828 1.828-1.828.984 0 1.828.844 1.828 1.828 0 .984-.844 1.828-1.828 1.828z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppearanceActive);
export default __webpack_public_path__ + "static/media/appearance_active.f834094a0e70206ab26aa5cb3a7f49b2.svg";
export { ForwardRef as ReactComponent };